<template>
    <div class="help-btn"  @mouseenter="showHelp">帮助中心</div>
</template>
<script>
export default {
    methods:{
        showHelp(){
            this.$emit('showCenter');
        },
    }
}
</script>
<style lang="less" scoped>
   .help-btn{
       position: fixed;
       width:50px;
       height:130px;
       font-size:14px;
       background: #FF3A3A;
       border-radius:10px 0px 0px 10px;
       right:18px;
       bottom:199px;
       transform: translateX(20px);
       z-index:99;
       padding:26px 18px;
       box-sizing: border-box;
       color: #fff;
       text-align: center;
   }
   .el-tabs__content{
       overflow-x: unset;
   }
</style>



// WEBPACK FOOTER //
// src/components/saas/helpBtn.vue